import React from 'react';
export default function breadcrumb() {
    return (React.createElement("div", { className: "row font-white breadcrumb-container" },
        React.createElement("div", { className: "small-12 large-10 large-centered columns breadcrumb" },
            "\u00A0",
            React.createElement("div", { className: "clearfix" }))));
}
